import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import ShareCertificateDocument from "../components/investor/ShareCertificateDocument";
import { fetchShareCertificateVerify } from "../services/investmentService";
import "../share-certificate.css";

export default function ShareCertificateVerifyPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError("");
    fetchShareCertificateVerify(token)
      .then((res) => {
        if (!cancelled) setData(res.data);
      })
      .catch((err) => {
        if (!cancelled) {
          const d = err?.response?.data?.detail;
          setError(typeof d === "string" ? d : "Could not verify this certificate.");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  if (loading) {
    return (
      <div className="share-cert-page share-cert-page--loading">
        <p className="muted">Verifying certificate…</p>
      </div>
    );
  }

  if (error && !data) {
    return (
      <div className="share-cert-page share-cert-page--error">
        <div className="share-cert-shell">
          <div className="card" style={{ padding: "1.5rem", textAlign: "center" }}>
            <h2 style={{ marginTop: 0 }}>Verification failed</h2>
            <p className="msg msg-error">{error}</p>
            <Link to="/login" className="btn-secondary">
              Go to platform
            </Link>
          </div>
        </div>
      </div>
    );
  }

  const valid = Boolean(data?.valid);

  return (
    <div className="share-cert-page">
      <div className="share-cert-shell">
        <ShareCertificateDocument data={data} />

        <div className="share-cert-actions">
          {valid ? (
            <button type="button" className="btn-primary" onClick={() => window.print()}>
              Print certificate
            </button>
          ) : null}
          <Link to="/login" className="btn-secondary">
            Need Healthcare platform
          </Link>
        </div>
      </div>
    </div>
  );
}
